import { Tooltip } from 'antd';
import React from 'react'
import { MetricCard } from '../../atoms';
import moment from 'moment'
import { Bargraph, CommentSection, DoughnutGraphHRA, RatingCard } from '../../organisms'
import {calender_img, healthCheckMale, family_img, rupee, info_img} from '../../../../assets/images'
import { PreferredPartner } from '../../molecules';
import { UserAlert } from '../../atoms/alerts';
import { commaingNumber } from '../../../../utils';

const SpendingAccount = ({metricObj, ratingObj, utilizationObj,loading}) => {
  const { start_date, end_date, employee_per_count,
         utilized_employees_count,utilized_employees_amount, 
         utilized_dependent_count, utilized_dependent_amount, 
         total_customers_amount,  utilized_amount_utilization,  
         avg_utilization_amount, donutData = [], partners = [], dependent_level = true } = metricObj; //done 
  const { ratingsPercent, totalratings, averagerating, commentSectionData } = ratingObj;//done
  const { barlabels, bardata = [], barBgColors, xAxesLabel } = utilizationObj;//need
  let maxLength = 0, stepLength = 0, max = 0 
  max  = Math.max(...bardata)
  const getRange = (max) => {
    if(max === 0) return 
    if(max < 25) {
      maxLength = 25 
      stepLength = 5
    }
    else if(max >= 25 && max < 100){
      maxLength = 100 
      stepLength = 20
    }
    else{
      let maxNumber = max + (100 - max % 5)
      stepLength = Math.round(maxNumber / 5)
      maxLength = stepLength * 5
    }
  }
  getRange(max)
  return (
    <div>
      <p className='mt-8 text-xs font-semibold uppercase tracking-wider text-gray-500'>Sponsored health checks</p>
      <div className={'mt-4 grid grid-cols-1 gap-5 ' + (dependent_level ? 'sm:grid-cols-2 xl:grid-cols-3' : 'sm:grid-cols-2')}> 
         <MetricCard
            variant='ds-default'
            hideMetricIcon
            title='Start date & end date'
            loading={loading}
            loaderHeight={120}
            svgsrc={calender_img} 
            titleClasses='text-gray-500 leading-4'
            metricClasses='mt-7  xl:mt-6'
            classes='min-w-0 flex-1'
            metricValue={(`${start_date} - ${end_date}`) || 0}
         />
          <MetricCard
            title='No. of employees who availed benefits'
            svgsrc={healthCheckMale}
            variant='ds-default'
            hideMetricIcon
            loading={loading} 
            loaderHeight={120}
            classes='min-w-0 flex-1'
            titleClasses='text-gray-500 leading-4 block'
            metricValue={commaingNumber(utilized_employees_count)}
         />
         { dependent_level &&
            <MetricCard
              title='No. of family members availed benefits'
              svgsrc={family_img} 
              variant='ds-default'
              hideMetricIcon
              loading={loading}
              loaderHeight={120}
              classes='min-w-0 flex-1'
              titleClasses='text-gray-500 leading-4 block'
              metricValue={commaingNumber(utilized_dependent_count)}
            />   
         }      
      </div>  
      <div className={'mt-5 grid grid-cols-1 gap-5 ' + (dependent_level ? 'sm:grid-cols-2 xl:grid-cols-3' : 'sm:grid-cols-2')}>
         <MetricCard
            variant='ds-default'
            hideMetricIcon
            title='Benefits / employee'
            loading={loading}
            loaderHeight={120}
            svgsrc={rupee} 
            titleClasses='text-gray-500 leading-4'
            classes='min-w-0 flex-1'
            metricValue={'₹ ' + (!employee_per_count ? 0 : employee_per_count.toLocaleString('en-IN') )}
         />
          <MetricCard
            title='Total amount utilized by employees'
            svgsrc={rupee} 
            variant='ds-default'
            hideMetricIcon
            loading={loading}
            loaderHeight={120}
            titleClasses='text-gray-500 leading-4 block'
            classes='min-w-0 flex-1'
            metricValue={'₹ ' + (!utilized_employees_amount ? 0 : utilized_employees_amount.toLocaleString('en-IN') )}
         />
         {  dependent_level && 
            <MetricCard
              title='Total amount utilized by family members'
              svgsrc={rupee} 
              loaderHeight={120}
              variant='ds-default'
              hideMetricIcon
              loading={loading}
              classes='min-w-0 flex-1'
              titleClasses='text-gray-500 leading-4 block'
              metricClasses='mt-5 xl:mt-5 2xl:mt-6'
              metricValue={'₹ ' + (!utilized_dependent_amount ? 0 : utilized_dependent_amount.toLocaleString('en-IN') )}
            />  
         }       
      </div>
        <div className='mt-12 flex flex-col gap-8 lg:flex-row'>
          <div className='flex flex-col lg:w-2/4 lg:pr-4'>
          <p className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>Average percentage utilization
          <Tooltip
              placement='top'
              title='Total amount utilized / Total amount allocated'
            >
              <img src={info_img} className='h-4 w-4 ml-2 inline text-gray-100' alt='info_icon' />
            </Tooltip>
          </p>  
          { !loading && donutData.length === 0  ? 
            <div className='h-full w-full rounded-xl border border-gray-200 bg-white shadow-sm'  >
             <UserAlert para='Data is not available' paraClasses='font-semibold text-gray-600' imgClasses='h-5 w-5' classes=' p-4 m-4'/>
           </div>
           : 
          <DoughnutGraphHRA
            loaderHeight={265}
            graphData ={donutData}
            loading={loading}
            hraCompleted={commaingNumber(utilized_amount_utilization)}
            totalCustomers={commaingNumber(total_customers_amount)}
            circleTitle ='Average utilization'
            title='Average percentage utilization'
            classes='h-full justify-center'
          />
          }  
          </div>
          <div className='flex flex-col lg:w-2/4'>
          <p className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>Average amount utilized per employee
          <Tooltip
              placement='top'
              color='pink'
              key='pink'
              title='Total amount utilized across the employees / total eligible employees'
            >
              <img src={info_img} className='h-4 w-4 ml-2 inline text-gray-100' alt='info_icon' />
            </Tooltip>
          </p>
          <div className='mt-3' style={{height : '92px'}}>
          <MetricCard
              title='Average amount utilized per employee'
              loading={loading}
              loaderHeight={92}
              titleClasses='text-gray-500 leading-4'
              subTitle={'₹ ' + ( avg_utilization_amount || 0) }
              subTitleClasses='text-2xl mb-4 mt-1.5 font-semibold text-gray-700'
              classes='h-full w-full'
              svgsrc={rupee} 
          />
          </div>
          <p className='mt-8 mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>
              Top preferred partners by your employees
            </p>
            { partners.length === 0 && !loading  ?
                <div className='w-full rounded-xl border border-gray-200 bg-white shadow-sm'  style={{height : '145px'}}  >
                  <UserAlert para='Data is not available' paraClasses='font-semibold text-gray-600' imgClasses='h-5 w-5' classes=' p-4 m-4'/>
                </div>
               :
               <div style={{height : '136px'}}>
                  <PreferredPartner
                    loaderHeight={129} 
                    loading={loading}
                    list={partners}  
                    classes='h-full' 
                  />
              </div>
            }
          </div>
        </div>
      <div className='mt-12 text-xs font-semibold uppercase tracking-wider text-gray-500'>Month on month total amount utilization</div>
      <div className='mt-4 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm'>
        {bardata && bardata.length === 0 && !loading && (
          <UserAlert
            para={`${xAxesLabel} data is not available`}
            paraClasses=' font-semibold text-gray-600'
            imgClasses=' h-5 w-5'
            classes='p-4'
          />
        )}
        <Bargraph withDownload
          id='utilizationBarGraph'
          loaderHeight={300}
          loading={loading}
          data={bardata}
          labels={barlabels}
          backgroundColor={barBgColors}
          height='300px'
          type='bar'
          ticks={{
            min: 0,
            max: (maxLength),
            stepSize: (stepLength),
          }}
          dataPoints='in-thousands'
          barTag='in-thousands'
          xAxesLabel={xAxesLabel || 'Months'}
          yAxesLabel='Amount utilization'
        />
      </div>
      <div className='mt-12 flex flex-col gap-8 lg:flex-row'>
        <div className='flex flex-col pr-4 lg:w-2/4'>
          <div className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>Ratings</div>
          <div className='mb-3 text-sm text-gray-600'>
          These ratings are captured after utilizing spending account
          </div>
          <RatingCard
            loading={loading}
            loaderHeight={200}
            rating={averagerating}
            number_of_ratings={totalratings}
            five_star_rating={ratingsPercent && ratingsPercent[4]}
            four_star_rating={ratingsPercent && ratingsPercent[3]}
            three_star_rating={ratingsPercent && ratingsPercent[2]}
            two_star_rating={ratingsPercent && ratingsPercent[1]}
            one_star_rating={ratingsPercent && ratingsPercent[0]}
            classes='h-full'
          />
        </div>
        <div className='flex w-full flex-col lg:w-2/4'>
          <div className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>Top comments</div>
          <div className='mb-3 text-sm text-gray-600'>
          These reviews are captured after utilizing spending account
          </div>
          <CommentSection 
          loaderHeight={200}
          loading={loading}
          points={commentSectionData || []} 
          classes='h-full' />
        </div>
      </div>
    </div>
  )
}

export default SpendingAccount